var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoKPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 90,
    viewBox: "0 0 63 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9222 89.9969C42.0469 89.9969 34.0802 84.3802 30.8507 75.8474L26.6677 64.8078C26.2387 63.805 25.7829 63.156 25.3002 62.8545C24.8146 62.5531 24.0281 62.4023 22.9406 62.4023H21.0786L19.9762 71.7349C18.7428 82.1593 10.1713 89.9969 0 89.9969L8.54166 18.259C9.78105 7.83451 18.3585 0 28.5328 0L22.5354 50.4399H23.757C24.7669 50.4399 25.5803 50.2799 26.203 49.96C26.8227 49.6401 27.4453 49.0588 28.065 48.2159L36.8152 35.8382C40.4023 30.7659 46.1047 27.7515 52.1855 27.7176L62.4193 27.6561L45.5327 49.84C44.7551 50.8828 43.903 51.8056 42.9705 52.6054C42.0379 53.4082 41.0667 54.1095 40.0597 54.7093C40.876 55.3922 41.5821 56.1827 42.1839 57.084C42.7858 57.9852 43.319 59.0188 43.7838 60.1815L55.8947 90H50.9222V89.9969Z",
    fill: "#EF2C5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKPink);
export default __webpack_public_path__ + "static/media/logo-k-pink.c1b6a1946866af488d8659ad31162b7e.svg";
export { ForwardRef as ReactComponent };